import { types } from 'mobx-state-tree';

import moment from 'moment-timezone';

import DateTime from '@utils/mst/types/DateTime';

import Coach from './Coach';
import OrganizationalService from './OrganizationalService';

const OrganizationalGroup = types
  .model('OrganizationalGroup', {
    id: types.identifierNumber,
    name: types.string,
    description: types.string,
    createdAt: DateTime,
    updatedAt: types.maybeNull(DateTime),
    deletedAt: types.maybeNull(DateTime),
    createdBy: types.reference(Coach),
    services: types.optional(types.array(types.reference(OrganizationalService)), []),
  })
  .views((self) => ({
    get createdAtMoment(): string {
      return moment(self.createdAt).format('DD MMMM YYYY hh:mm A');
    },
  }));

export default OrganizationalGroup;
